import React from "react";

const CateringDishFields = ({ values, errors, setFieldValue, setFieldTouched }) => (
  <div className="row">
    {[['halfTrayPrice', 'Half Tray Price'], ['fullTrayPrice', 'Full Tray Price']].map(([name, label]) => (
      <div className="col-md-6 mb-3" key={name}>
        <label className="form-label">{label}</label>
        <input
          type="number"
          min="0.01"
          step="0.01"
          name={name}
          value={values?.[name] || ''}
          className={`form-control ${errors?.[name] ? 'is-invalid' : ''}`}
          onChange={event => setFieldValue(name, event.target.value)}
          onBlur={() => setFieldTouched?.(name, true)}
        />
        {errors?.[name] && <span className="text-danger">{errors[name]}</span>}
      </div>
    ))}
  </div>
);

export default CateringDishFields;
